import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { CustomerListPage } from "pages/app/customer-list/CustomerListPage";
import { getCustomers } from "api/customer.api";
import userStore from "store/user.store";

const customerListSearchSchema = z.object({
  customerquery: z.string().optional().catch(undefined),
  includeDeleted: z.boolean().optional().catch(undefined),
  page: z.number().int().positive().optional().catch(1),
});

const PAGE_SIZE = 20;

export const Route = createFileRoute("/_authenticated/app/kunder/")({
  validateSearch: customerListSearchSchema,
  beforeLoad: ({ context: { queryClient }, search }) => {
    const companyId = userStore.getState().user?.companyId ?? null;

    const params = {
      query: search.customerquery ?? "",
      offset: ((search.page ?? 1) - 1) * PAGE_SIZE,
      limit: PAGE_SIZE,
      includeDeleted: search.includeDeleted ?? false,
      companyId,
    };

    // Fire-and-forget: awaiting here blocks the navigation until the fetch
    // completes, so the page never sees a loading state (search spinner and
    // PageLoader were dead code). Prefetch warms the cache without blocking.
    void queryClient.prefetchQuery(getCustomers(params));
  },
  component: CustomerListPage,
});
